import React, { createContext, useContext } from 'react';
interface PricingContextType {
  price: string;
  priceValue: number;
  currency: string;
  currencySymbol: string;
  isEurope: boolean;
  isLoading: boolean;
}
const PricingContext = createContext<PricingContextType>({
  price: '€299',
  priceValue: 299,
  currency: 'EUR',
  currencySymbol: '€',
  isEurope: true,
  isLoading: false
});
export function PricingProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const value: PricingContextType = {
    price: '€299',
    priceValue: 299,
    currency: 'EUR',
    currencySymbol: '€',
    isEurope: true,
    isLoading: false
  };
  return <PricingContext.Provider value={value} data-id="element-400" data-mp="10pxw5jwz4gu3">{children}</PricingContext.Provider>;
}
export function usePricing() {
  return useContext(PricingContext);
}